export const environment = {
    PROD_MODE: true,
    API_URL: "https://api.ncsmcp.org"
  };
  